"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDiscountDepositText = exports.generatePriceDescriptionText = exports.generateRetailProductPriceInformation = exports.generateUnitText = exports.generateRetailProductDescription = exports.generateProductItemValues = exports.generateDescription = exports.getComparePricePerKg = void 0;
var values_1 = require("../../utils/values");
var getPackageSizeInKg = function (packageSize, packageUnit) {
    if (packageSize) {
        var packageSizeFloat = typeof packageSize == 'number' ? packageSize : parseFloat(packageSize);
        var packageUnitLowerCase = packageUnit ? packageUnit.toLowerCase() : undefined;
        if (packageUnitLowerCase === 'kg') {
            return packageSizeFloat;
        }
        else if (packageUnitLowerCase === 'g') {
            return packageSizeFloat / 1000;
        }
    }
    return undefined;
};
var getPackagePriceForKg = function (price, unit) {
    var unitLowerCase = unit ? unit.toLowerCase() : undefined;
    if (price &&
        (unitLowerCase === 'kg' ||
            unitLowerCase === 'kpl' ||
            unitLowerCase === 'pss' ||
            unitLowerCase === 'ras')) {
        return price;
    }
    else if (price && unitLowerCase === 'g') {
        return price / 1000;
    }
    return undefined;
};
var getComparePricePerKg = function (price, unit, packageSize, packageUnit) {
    if (typeof price == 'number' && unit && packageSize && packageUnit) {
        var priceEuros = price / 100;
        var packageSizeInKg = getPackageSizeInKg(packageSize, packageUnit);
        var packagePriceForKg = getPackagePriceForKg(priceEuros, unit);
        if (packageSizeInKg && packagePriceForKg) {
            var eurosPerKg = packagePriceForKg / packageSizeInKg;
            return eurosPerKg.toFixed(2).replace('.', ',');
        }
    }
    return undefined;
};
exports.getComparePricePerKg = getComparePricePerKg;
var generateDescription = function (description, country, qualityClass, comparePricePerKg) {
    var strings = [];
    if (qualityClass) {
        strings.push(qualityClass);
    }
    if (country) {
        strings.push(country);
    }
    if (description) {
        strings.push(description);
    }
    if (comparePricePerKg) {
        strings.push("".concat(comparePricePerKg, " \u20AC/Kg"));
    }
    return strings.length > 0 ? strings.join(' ') : undefined;
};
exports.generateDescription = generateDescription;
var generateProductItemValues = function (_a) {
    var price = _a.price, unit = _a.unit, packageSize = _a.packageSize, packageUnit = _a.packageUnit, description = _a.description, country = _a.country, qualityClass = _a.qualityClass;
    var priceIntegers = (0, values_1.getEurosString)(price);
    var priceDecimals = (0, values_1.getDecimalsString)(price);
    var comparePricePerKg = getComparePricePerKg(price, unit, packageSize, packageUnit);
    // Show comparison price always except when sales price is same than comparison price.
    var comparePrice = comparePricePerKg === "".concat(priceIntegers, ",").concat(priceDecimals) ? undefined : comparePricePerKg;
    var itemDescription = generateDescription(description, country, qualityClass, comparePrice);
    return {
        priceIntegers: priceIntegers,
        priceDecimals: priceDecimals,
        comparePrice: comparePrice,
        itemDescription: itemDescription
    };
};
exports.generateProductItemValues = generateProductItemValues;
var generateRetailProductDescription = function (_a) {
    var country = _a.country, qualityClass = _a.qualityClass;
    var strings = [];
    if (country) {
        strings.push(country);
    }
    if (qualityClass) {
        strings.push(qualityClass);
    }
    return strings.length > 0 ? strings.join(', ') : undefined;
};
exports.generateRetailProductDescription = generateRetailProductDescription;
var generateUnitText = function (unit, discountBatchSize) {
    if (unit && discountBatchSize && discountBatchSize > 1) {
        return "".concat(discountBatchSize, " ").concat(unit);
    }
    else if (unit) {
        return unit;
    }
    return '';
};
exports.generateUnitText = generateUnitText;
var generateDiscountText = function (_a) {
    var discountUnitPrice = _a.discountUnitPrice, unitPriceUnit = _a.unitPriceUnit;
    if (discountUnitPrice && unitPriceUnit) {
        var _b = (0, values_1.convertRetailProductPrice)(parseFloat(discountUnitPrice)), integers = _b.integers, decimals = _b.decimals;
        return "(".concat(integers, ",").concat(decimals, "/").concat(unitPriceUnit, ")");
    }
    return '';
};
var generateRetailProductPriceInformation = function (price, item) { return (__assign(__assign({}, (0, values_1.convertRetailProductPrice)(price)), { unitText: generateUnitText(item.unit, item.discountBatchSize), discountText: generateDiscountText(item) })); };
exports.generateRetailProductPriceInformation = generateRetailProductPriceInformation;
var generatePriceDescriptionText = function (_a) {
    var discountType = _a.discountType, price = _a.price, unitPrice = _a.unitPrice, unit = _a.unit, unitPriceUnit = _a.unitPriceUnit, deposit = _a.deposit;
    var strings = [];
    if (price && discountType === 'plussa' && unit) {
        var _b = (0, values_1.convertRetailProductPrice)(price), integers = _b.integers, decimals = _b.decimals;
        var plussaPriceString = "Yksitt\u00E4in ja ilman Plussa-korttia ".concat(integers, ",").concat(decimals, " ").concat(unit);
        var unitString = '';
        if (unitPrice && unitPriceUnit) {
            var _c = (0, values_1.convertRetailProductPrice)(parseFloat(unitPrice)), unitPriceIntegers = _c.integers, unitPriceDecimals = _c.decimals;
            unitString = " (".concat(unitPriceIntegers, ",").concat(unitPriceDecimals, "/").concat(unitPriceUnit, ")");
        }
        strings.push("".concat(plussaPriceString).concat(unitString));
    }
    else if (price && discountType === 'normal' && unit) {
        var _d = (0, values_1.convertRetailProductPrice)(price), integers = _d.integers, decimals = _d.decimals;
        var normalPriceString = "Normaali hinta ".concat(integers, ",").concat(decimals, " ").concat(unit);
        var unitString = '';
        if (unitPrice && unitPriceUnit) {
            var _e = (0, values_1.convertRetailProductPrice)(parseFloat(unitPrice)), unitPriceIntegers = _e.integers, unitPriceDecimals = _e.decimals;
            unitString = " (".concat(unitPriceIntegers, ",").concat(unitPriceDecimals, "/").concat(unitPriceUnit, ")");
        }
        strings.push("".concat(normalPriceString).concat(unitString));
    }
    if (deposit) {
        var _f = (0, values_1.convertRetailProductPrice)(deposit), integers = _f.integers, decimals = _f.decimals;
        var firstLetter = strings.length > 0 ? 'h' : 'H';
        strings.push("".concat(firstLetter, "inta sis\u00E4lt\u00E4\u00E4 pantin ").concat(integers, ",").concat(decimals, "."));
    }
    return strings.length > 0 ? strings.join(', ') : undefined;
};
exports.generatePriceDescriptionText = generatePriceDescriptionText;
var generateDiscountDepositText = function (_a) {
    var discountDeposit = _a.discountDeposit;
    if (discountDeposit) {
        var _b = (0, values_1.convertRetailProductPrice)(discountDeposit), integers = _b.integers, decimals = _b.decimals;
        return "Tarjous sis\u00E4lt\u00E4\u00E4 pantin ".concat(integers, ",").concat(decimals, ".");
    }
    return undefined;
};
exports.generateDiscountDepositText = generateDiscountDepositText;
//# sourceMappingURL=itemInformation.js.map